import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'openIcon', 'closeIcon', 'overlay']

  connect() {
    this.isOpen = false
    // Close on escape key
    this.handleEscape = this.handleEscape.bind(this)
    document.addEventListener('keydown', this.handleEscape)
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape)
    this.enableScroll()
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    this.menuTarget.classList.remove('translate-x-full')
    this.menuTarget.classList.add('translate-x-0')
    this.overlayTarget.classList.remove('opacity-0', 'pointer-events-none')
    this.overlayTarget.classList.add('opacity-100')
    this.openIconTarget.classList.add('hidden')
    this.closeIconTarget.classList.remove('hidden')
    this.disableScroll()
  }

  close() {
    this.isOpen = false
    this.menuTarget.classList.add('translate-x-full')
    this.menuTarget.classList.remove('translate-x-0')
    this.overlayTarget.classList.add('opacity-0', 'pointer-events-none')
    this.overlayTarget.classList.remove('opacity-100')
    this.openIconTarget.classList.remove('hidden')
    this.closeIconTarget.classList.add('hidden')
    this.enableScroll()
  }

  handleEscape(event) {
    if (event.key === 'Escape' && this.isOpen) {
      this.close()
    }
  }

  disableScroll() {
    document.body.style.overflow = 'hidden'
  }

  enableScroll() {
    document.body.style.overflow = ''
  }
}
